import { Modal, Center, Loader, Text, Stack } from '@mantine/core';
import { useEffect } from 'react';
import { useApify } from './use-apify';
import DataError from './data-error';

interface WebsiteFetchedProps {
  opened: boolean;
  websiteUrl: string;
  websiteConfirmed: boolean;
  onCrawled: (datasetId: string) => void;
  onClose: () => void;
}

function WebsiteCrawlModal({
  opened,
  websiteUrl,
  websiteConfirmed,
  onCrawled,
  onClose,
}: WebsiteFetchedProps) {
  const { data, loading, error } = useApify(websiteUrl, { skip: !websiteUrl || !websiteConfirmed });

  useEffect(() => {
    if (data?.datasetId) {
      console.log(`we have data.datasetId, calling onCrawled() [${data.datasetId}]`);
      onCrawled(data.datasetId);
    }
  }, [data, onCrawled]);

  // TODO: better messaging  for being able to get the url.. specific to the url
  if (error) return <DataError error={error} />;
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      closeOnEscape={false}
      closeOnClickOutside={false}
      trapFocus
      // title={
      //   <Text c="btb-navy" fz="xl" fw={700}>
      //     Obtaining your website content, this may take several minutes. Please be patient...
      //   </Text>
      // }
      size="xl"
    >
      {loading && (
        <Center style={{ height: 200 }}>
          <Stack align="center">
            <Text fz="xl" c="btb-navy">
              Obtaining your website content, this may take several minutes.
            </Text>
            <Text fz="xl" c="btb-navy">
              Please be patient...
            </Text>
            <Loader type="dots" />
          </Stack>
        </Center>
      )}
    </Modal>
  );
}

export { WebsiteCrawlModal };
